import gql from 'graphql-tag'

export const FACILITY_DETAILS_QUERY = gql`
  query facilityDetails($facilityId: Int!) {
    facilityDetails(facilityId: $facilityId) {
      address
      latitude
      longitude
      city
      state
      zip
      website
    }
  }
`
